import ApiClient from './ApiClient';

class ExternalMessagesAPI extends ApiClient {
  constructor() {
    super('external_messages', { accountScoped: true });
  }
}

export default new ExternalMessagesAPI();
